<!-- <div class="detail-header">
  <p style="font-size: 12px" class="mb-1">
    Please provide details to continue payment
  </p>
</div>

<div>
  @if (timeoutSignal()) {
    <src-loader></src-loader>
  } @else {
    <src-card-list
      id="srcCardList"
      locale=""
      card-brands="visa,mastercard,amex"
      display-cancel-option="false"
      display-add-card="true"
      display-preferred-card="true"
      display-sign-out="false"
      card-selection-type="radioButton"
      display-header="true"
      unaccepted-card-type=""
      background="default"
    >
    </src-card-list>
  }
</div>

@if (addCardClicked()) {
  <form [formGroup]="cardForm" (submit)="sendTxnData()">
    <div class="detail-header">
      <p style="font-size: 12px" class="mb-1">
        Please provide details to continue payment
      </p>
    </div>

    <div class="flex-container">
      <input
        class="form-control form__control"
        id="pan"
        formControlName="pan"
        maxlength="23"
        type="text"
        required
        placeholder="Card Number"
        #ccNumber
        appCardFormatting
        (change)="logActivity($event.target.value)"
        (input)="moveToNext($event, exp, 'card')"
      />

      <label for="pan" style="visibility: hidden">Card Number</label>
      <ng-container *ngIf="f.pan.errors?.isPanValid">
        <span class="validation-message">
          Invalid Card Number
          <br />
        </span>
      </ng-container>
    </div>
    <div class="flex-container">
      <div style="flex-basis: 47%">
        <input
          class="form-control form__control"
          id="expiryDate"
          type="tel"
          maxlength="5"
          minlength="0"
          formControlName="expiryDate"
          #exp
          (keyup)="formatExpDate(exp.value, $event)"
          placeholder="Exp(MM/YY)"
          autocomplete="new-password"
          (change)="logActivity($event.target.value, 'expiryDate')"
          (input)="moveToNext($event, cvv, 'expiry')"
          (keypress)="validateInput($event)"
        />
        <label for="expiryDate" style="visibility: hidden">Exp(MM/YY)</label>
      </div>
      <div style="flex-basis: 47%">
        <input
          class="form-control form__control"
          id="cvv"
          type="password"
          inputmode="numeric"
          pattern="[0-9]*"
          maxlength="3"
          minlength="0"
          formControlName="cvv2"
          placeholder="CVV"
          #cvv
          (change)="logActivity($event.target.value, 'cvv')"
          (input)="moveToNext($event, pin, 'cvv')"
          (keypress)="validateInput($event)"
        />
        <label for="cvv" style="visibility: hidden">CVV</label>
        <ng-container
          *ngIf="f.cvv2.errors && (f.cvv2.touched || f.cvv2.dirty)"
          class="validation-message"
        >
          <span class="validation-message">
            Invalid cvv
            <br />
          </span>
        </ng-container>
      </div>
    </div>
    <div class="flex-container">
      <input
        class="form-control form__control"
        id="PhoneNumber"
        type="password"
        inputmode="numeric"
        pattern="[0-9]*"
        formControlName="pin"
        required
        placeholder="Card PIN"
        autocomplete="new-password"
        #pin
        (keypress)="validateInput($event)"
      />
      <label for="PhoneNumber" style="visibility: hidden">Card PIN</label>
      <ng-container *ngIf="f.pin.errors && (f.pin.dirty || f.pin.touched)">
        <span class="validation-message" [hidden]="!f.pin.hasError('required')">
          input your card pin
          <br />
        </span>
      </ng-container>
    </div>

    <div class="flexed flex-row">
      <input type="checkbox" class="mr-2" />
      <p>
        Save my information with Mastercard
        <br />
        <span [style.color]="'#ed1c25'">Click to Pay</span> for fast, secure
        checkout
      </p>
    </div>

    <div class="flex-container">
      <button
        [disabled]="!cardForm.valid"
        class="btn w-100 form-btn text-white no-margin-l no-margin-r"
        [style.background-color]="
          whiteLabelInfo?.brandColor ? whiteLabelInfo?.brandColor : '#ed1c25'
        "
        type="submit"
      >
        <span>Pay</span>
      </button>
    </div>

    <div
      class="footer"
      style="margin-top: 70px; text-align: center; font-size: 8px"
    >
      <app-footer [whiteLabelInfo]="whiteLabelInfo" />
    </div>
  </form>
} -->

<form [formGroup]="cardForm" (submit)="sendTxnData()">
  <div class="detail-header">
    <p class="detail-header-para" class="mb-1">
      Please provide details to continue payment
    </p>
  </div>
  <div class="flex-container">
    <input
      class="form-control"
      id="pan"
      formControlName="pan"
      maxlength="23"
      type="text"
      required
      placeholder="Card Number"
      #ccNumber
      appCardFormatting
      (change)="logActivity($event.target.value)"
      (input)="moveToNext($event, exp, 'card')"
    />

    <label for="pan" style="visibility: hidden">Card Number</label>
    <ng-container *ngIf="f.pan.errors?.isPanValid">
      <span class="validation-message">
        Invalid Card Number
        <br />
      </span>
    </ng-container>
  </div>
  <div class="flex-container">
    <div style="flex-basis: 47%">
      <input
        class="form-control"
        id="expiryDate"
        type="tel"
        maxlength="5"
        minlength="0"
        formControlName="expiryDate"
        #exp
        (keyup)="formatExpDate(exp.value, $event)"
        placeholder="Exp(MM/YY)"
        autocomplete="new-password"
        (change)="logActivity($event.target.value, 'expiryDate')"
        (input)="moveToNext($event, cvv, 'expiry')"
        (keypress)="validateInput($event)"
      />
      <label for="expiryDate" style="visibility: hidden">Exp(MM/YY)</label>
    </div>
    <div style="flex-basis: 47%">
      <input
        class="form-control"
        id="cvv"
        type="password"
        inputmode="numeric"
        pattern="[0-9]*"
        maxlength="3"
        minlength="0"
        formControlName="cvv2"
        placeholder="CVV"
        #cvv
        (change)="logActivity($event.target.value, 'cvv')"
        (input)="moveToNext($event, pin, 'cvv')"
        (keypress)="validateInput($event)"
      />
      <label for="cvv" style="visibility: hidden">CVV</label>
      <ng-container
        *ngIf="f.cvv2.errors && (f.cvv2.touched || f.cvv2.dirty)"
        class="validation-message"
      >
        <span class="validation-message">
          Invalid cvv
          <br />
        </span>
      </ng-container>
    </div>
  </div>
  <div class="flex-container">
    <input
      class="form-control"
      id="PhoneNumber"
      type="password"
      inputmode="numeric"
      pattern="[0-9]*"
      formControlName="pin"
      required
      placeholder="Card PIN"
      autocomplete="new-password"
      #pin
      (keypress)="validateInput($event)"
    />
    <label for="PhoneNumber" style="visibility: hidden">Card PIN</label>
    <ng-container *ngIf="f.pin.errors && (f.pin.dirty || f.pin.touched)">
      <span class="validation-message" [hidden]="!f.pin.hasError('required')">
        input your card pin
        <br />
      </span>
    </ng-container>
  </div>

  <div class="flex-container">
    <button
      [disabled]="!cardForm.valid"
      class="btn w-100 form-btn text-white no-margin-l no-margin-r"
      [style.background-color]="
        whiteLabelInfo?.brandColor ? whiteLabelInfo?.brandColor : '#ed1c25'
      "
      type="submit"
    >
      <span>Pay</span>
    </button>
  </div>

  <div
    class="footer"
    style="margin-top: 70px; text-align: center; font-size: 8px"
  >
    <app-footer [whiteLabelInfo]="whiteLabelInfo" />
  </div>
</form>
